// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__12bwf","description":"PatientConsentPreview_description__3ytgp"};